import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './auth.service';

@Component({
  standalone: true,
  template: '<em>Redirecting...</em>',
  selector: 'tt-auth-logout',
})
export class LogoutComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  constructor() {
    this.authService.logout();
    this.router.navigate(['/']);
  }
}
